/* © NXAPP Limited */
/**
 * A tiny per-row breakdown table: metrics down the side, Today / This week /
 * This month across the top. Used inside list rows so each search / campaign
 * states its own periods explicitly (no more ambiguous bare numbers).
 *
 * Built from divs in a CSS grid (not a <table>) so it's valid inside a clickable
 * <button> or <a> row.
 */
import type { Split } from '@/lib/trend'
import type { Tone } from './TrendStrip'

const LABEL_TONE: Record<Tone, string> = {
  teal: 'text-teal-700', indigo: 'text-indigo-700', amber: 'text-amber-700',
  green: 'text-green-700', rose: 'text-rose-700', gray: 'text-gray-600',
}

export interface RowSplitMetric { label: string; tone: Tone; split: Split }

export default function RowSplit({ metrics }: { metrics: RowSplitMetric[] }) {
  return (
    <span className="grid grid-cols-[1fr_auto_auto_auto] gap-x-3 gap-y-0.5 text-[10px] leading-tight">
      <span />
      <span className="text-right text-gray-400 uppercase tracking-wide">Today</span>
      <span className="text-right text-gray-400 uppercase tracking-wide">Wk</span>
      <span className="text-right text-gray-400 uppercase tracking-wide">Mo</span>
      {metrics.map(m => (
        <span key={m.label} className="contents">
          <span className={`truncate font-medium ${LABEL_TONE[m.tone]}`}>{m.label}</span>
          <span className="text-right tabular-nums text-gray-800">{m.split.today}</span>
          <span className="text-right tabular-nums text-gray-500">{m.split.week}</span>
          <span className="text-right tabular-nums text-gray-500">{m.split.month}</span>
        </span>
      ))}
    </span>
  )
}
